export default __webpack_public_path__ + "static/media/JellyCloud.3243ed77.ttf";